export default theme => ({
  root: {
    margin: theme.spacing(1),
    minWidth: 120,
    backgroundColor: theme.palette.common.white
  }
});
